export default __webpack_public_path__ + "static/create-new-feature-flag-light-mode-3a1d7007501cb7f5ec2ec780c3e2ff99.png";